export const CREATE_SCHEDULE_RULE = 'CREATE_SCHEDULE_RULE'
export const UPDATE_SCHEDULE_RULE = 'UPDATE_SCHEDULE_RULE'
export const DELETE_SCHEDULE_RULE = 'DELETE_SCHEDULE_RULE'